import React from 'react'
import { I18n } from '@front/volcanion/'

import { Grid } from '@mui/material'
import { TextField } from '@front/squirtle'

const IdentifierPinForm = () => (
  <Grid container rowSpacing={2}>
    <Grid size={12}>
      <TextField
        name='identifier'
        label={I18n.t('identifier.label', { count: 1 })}
        required
        autoFocus
      />
    </Grid>
    <Grid size={12}>
      <TextField
        name='pin'
        label={I18n.t('pin.label', { count: 1 })}
        required
      />
    </Grid>
  </Grid>
)

export default IdentifierPinForm
